import { useState } from 'react';
import { toast } from 'react-toastify';

export default function CopyToClipboardButton({ text }) {
    const [clickedField, setClickedField] = useState(false);
    const handleClick = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                setClickedField(text);
                toast.info('Copied to clipboard!');
                setTimeout(() => setClickedField(false), 1500); // Reset after 1.5s
            })
            .catch(err => console.error('Copy failed', err));
    };

    return (
        <i
            className={clickedField ? "bi bi-check-circle text-success ms-2" : "bi bi-clipboard ms-2"}
            style={{ cursor: 'pointer' }}
            onClick={() => handleClick(text)}
        ></i>
    );
}